import Marquee from "react-fast-marquee";
import { Buildings, Factory, Storefront, Warehouse } from "@phosphor-icons/react";

const TEAM_IMAGE = "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/bcoq4hnm_48A15ADA-091B-4931-AC58-281F75EB1E09.PNG";
const WORK_IMAGE = "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/cxov7j1l_ACCA3BF1-E7DE-4F91-A990-FFF637927569.PNG";

const clientLogos = [
  { name: "Tiendas D1", logo: "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/g1vxc1xv_D1.png" },
  { name: "ITALCOL", logo: "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/8qlj65vn_ITALCOL.png" },
  { name: "Cargill", logo: "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/f2vqbpw5_CARGILL.png" },
  { name: "Brillaseo", logo: "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/qam6o4yp_BRILLASEO.png" },
  { name: "Huevos Kikes", logo: "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/jmq2ab37_KIKES.png" },
  { name: "Holguines Trade Center", logo: "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/jsh7i3qa_HOLGINES.png" },
  { name: "Centro Comercial Alfaguara", logo: "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/b3cuqhzd_ALFAGURA.jpg" },
  { name: "MTS", logo: "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/gymr234z_MTS.png" },
];

const experienceTypes = [
  { icon: Storefront, text: "Adecuación de locales comerciales" },
  { icon: Factory, text: "Mantenimiento preventivo nacional" },
  { icon: Warehouse, text: "Bodegas y centros logísticos" },
  { icon: Buildings, text: "Soporte operativo en plantas" }
];

export function ExperienceSection() {
  return (
    <section
      id="experiencia"
      data-testid="experience-section"
      className="section-padding bg-slate-50 relative overflow-hidden"
    >
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-0.5 bg-[#C92127]" />
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              Nuestra Experiencia
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 mb-6">
            Respaldados por <span className="text-[#C92127]">grandes empresas</span>
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Contamos con experiencia en atención de compañías del sector industrial, 
            comercial, logístico y retail, ejecutando trabajos que requieren cumplimiento, 
            rapidez de respuesta y mínima afectación operativa.
          </p>
        </div>

        {/* Images Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="relative rounded-xl overflow-hidden shadow-xl group">
            <img
              src={TEAM_IMAGE}
              alt="Equipo SEINMAR frente a Tiendas D1"
              className="w-full h-[350px] object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 text-white">
              <p className="text-sm uppercase tracking-wider text-white/80 mb-1">Equipo SEINMAR</p>
              <p className="text-xl font-bold">Tiendas D1 - Proyecto Regional</p>
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden shadow-xl group">
            <img
              src={WORK_IMAGE}
              alt="Trabajadores SEINMAR en obra"
              className="w-full h-[350px] object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 text-white">
              <p className="text-sm uppercase tracking-wider text-white/80 mb-1">En Acción</p>
              <p className="text-xl font-bold">Mantenimiento Industrial</p>
            </div>
          </div>
        </div>

        {/* Experience Types */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {experienceTypes.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-4 p-6 bg-white rounded-xl border border-slate-200 hover:border-[#C92127]/30 hover:shadow-lg transition-all"
              >
                <div className="w-12 h-12 rounded-lg bg-[#C92127]/10 flex items-center justify-center flex-shrink-0">
                  <Icon size={24} weight="duotone" className="text-[#C92127]" />
                </div>
                <p className="text-sm font-semibold text-slate-700">{item.text}</p>
              </div>
            );
          })}
        </div>

        {/* Clients Marquee */}
        <div className="bg-white rounded-xl border border-slate-200 py-8 overflow-hidden">
          <p className="text-center text-xs uppercase tracking-[0.2em] text-slate-500 mb-6">
            Clientes que confían en nosotros
          </p>
          <Marquee
            gradient={true}
            gradientColor="#FFFFFF"
            gradientWidth={100}
            speed={40}
            pauseOnHover={true}
          >
            {clientLogos.map((client, index) => (
              <div
                key={index}
                className="mx-12 flex items-center justify-center"
              >
                <img 
                  src={client.logo} 
                  alt={client.name}
                  className="h-16 md:h-20 w-auto object-contain hover:scale-110 transition-transform duration-300"
                />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}

export default ExperienceSection;
